export default __webpack_public_path__ + "static/media/306.4fb6ef7c.jpg";